export const getUserStatus = (state) => ({
    status: 'good',
    metadata: {},
    ...state.entities.userStatus,
});

export const getUserIsFirstTimeBorrower = (state) =>
    state.entities.userStatus.metadata
        ? state.entities.userStatus.metadata.firstOrder
        : false;
